'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../aviary-core/dist/cjs/index.cjs');

/**
 * SVG Illustration of telemedicine
 */ const Telemedicine = ({ assetColor = index.ASSET_COLORS.grey, size = index.ILLUSTRATION_DIMENSIONS.medium, ...rest })=>{
    const theme = react.useTheme();
    return /*#__PURE__*/ jsxRuntime.jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "52",
                cy: "52",
                r: "52",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "43.3975",
                y: "68.6965",
                width: "17.4267",
                height: "5.17625",
                rx: "2.33602",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M40.909 19H63.1865C64.8049 19.009 66.3542 19.6569 67.497 20.8028C68.6398 21.9486 69.2836 23.4996 69.288 25.1178V78.4869C69.2836 80.1081 68.6375 81.6615 67.491 82.8079C66.3445 83.9542 64.7908 84.6002 63.1695 84.6047H40.892C39.2706 84.6002 37.717 83.9542 36.5705 82.8079C35.424 81.6615 34.7779 80.1081 34.7734 78.4869V66.7484V59.1935V57.3381V25.1178C34.7779 23.4937 35.4263 21.9376 36.5765 20.7908C37.7266 19.644 39.2847 19 40.909 19Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M58.6015 68.7781H45.4891C44.0928 68.7781 42.9609 69.9098 42.9609 71.3059C42.9609 72.702 44.0928 73.8337 45.4891 73.8337H58.6015C59.9978 73.8337 61.1296 72.702 61.1296 71.3059C61.1296 69.9098 59.9978 68.7781 58.6015 68.7781Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "49.146",
                y: "73.8337",
                width: "5.98901",
                height: "5.85592",
                rx: "2.92796",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "37.4346",
                y: "21.9282",
                width: "29.4127",
                height: "48.4444",
                rx: "2.86482",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "52",
                cy: "46",
                r: "7",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M52 37C47.0372 37 43 41.0372 43 46C43 50.9628 47.0372 55 52 55C56.9628 55 61 50.9628 61 46C61 41.0372 56.9628 37 52 37ZM57.7178 47.745H53.7794V51.7163H50.2436V47.745H46.2822V44.2708H50.2436V40.2822H53.7794V44.2708H57.7178V47.745Z",
                fill: theme.ds5.asset[assetColor]["500"]
            })
        ]
    });
};

exports.Telemedicine = Telemedicine;
//# sourceMappingURL=Telemedicine.cjs.map
